import configData from '../../config'
import * as dateFiltersGetters from './store/date-filters-getters'
import * as filtersGetters from './store/filters-getters'
import convertToIso from './../../scripts/modules/local-iso-string'

const escapeValue = (value) => {
  let escaped = value.replace(/([^"\\]*(?:\\.[^"\\]*)*)"/g, '$1\\"')
  return '"' + escaped + '"'
}

const getFbcQuery = (newspaperTitle) => {
  let dateFrom = dateFiltersGetters.getDateFromStatic()
  let dateTo = dateFiltersGetters.getDateToStatic()

  let filters = filtersGetters.getFilterParamsStatic()
  let languages = []
  let dataProvider = []

  filters.forEach(function(elem) {
    if (elem.name == "language") {
      languages = elem.filters
    }
    if (elem.name == "data_provider") {
      dataProvider = elem.filters
    }
  })

  let queryString =  configData().FBC.query.titleFilter + escapeValue(newspaperTitle)

  if (dateFrom != '' && dateTo != '') {
    dateFrom = new Date(dateFrom)
    dateTo = new Date(dateTo)

    dateFrom.setHours(0,0,0,0)
    dateTo.setHours(23,59,59,999)

    queryString += '&' + configData().FBC.query.fqPrefix
    queryString += configData().FBC.query.dateFilter
    queryString += "[" + convertToIso(dateFrom) + ' TO ' + convertToIso(dateTo) + "]"
  }

  if (languages.length > 0) {
    queryString += '&' + configData().FBC.query.fqPrefix + configData().FBC.query.languageFilter

    languages.forEach(function(elem, index) {
      queryString += configData().FBC.query.languageFilters + elem
      if (index < languages.length - 1) {
        queryString += ' OR '
      }
    })
  }

  if (dataProvider.length > 0) {
    queryString += '&' + configData().FBC.query.fqPrefix + configData().FBC.query.dataProviderFilter

    dataProvider.forEach(function(elem, index) {
      queryString += configData().FBC.query.dataProviderFilters + "\"" + elem + "\""
      if (index < dataProvider.length - 1) {
        queryString += ' OR '
      }
    })
  }

  queryString += configData().FBC.query.sortBy

  return queryString
}

export default getFbcQuery



// WEBPACK FOOTER //
// ./src/scripts/modules/search-results.js